export default "__VITE_ASSET__d6f29b35__"